import News from './News'
import './News.css'
import './background.css'

export default News



// WEBPACK FOOTER //
// ./src/components/News/index.js